export const getStore = () => import(
  /* webpackChunkName: 'm_share' */
  './store');